/**
 * Super Admin Login — lives at a secret path, not linked from anywhere.
 * Path is configured via REACT_APP_SA_PATH in dashboard/.env
 * Example: REACT_APP_SA_PATH=sa-a7f3d9e2   → route is /sa-a7f3d9e2
 *
 * NEVER link to this page from the regular login screen.
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../store/auth';
import toast from 'react-hot-toast';

export default function SuperAdminLogin() {
  const [u, setU]           = useState('');
  const [p, setP]           = useState('');
  const [loading, setLoading] = useState(false);
  const { login }           = useAuth();
  const navigate            = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(u, p);
      navigate('/');
    } catch {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
                  height:'100vh', background:'var(--bg)' }}>
      <div style={{ background:'var(--surface)', borderRadius:12,
                    border:'1px solid var(--border)', width:360, padding:'32px' }}>
        <div style={{ textAlign:'center', marginBottom:24 }}>
          <h1 style={{ fontSize:20, fontWeight:700, marginBottom:4 }}>ClassRMM</h1>
          <p style={{ color:'var(--muted)', fontSize:12 }}>Super Admin Access</p>
        </div>

        <form onSubmit={submit}>
          <label style={labelStyle}>Username</label>
          <input value={u} onChange={e => setU(e.target.value)} required
                 autoComplete="username"
                 placeholder="Username" style={inputStyle} />

          <label style={labelStyle}>Password</label>
          <input value={p} onChange={e => setP(e.target.value)} type="password" required
                 autoComplete="current-password"
                 style={{ ...inputStyle, marginBottom:24 }} />

          <button type="submit" disabled={loading} style={submitBtn}>
            {loading ? 'Authenticating…' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

const inputStyle = {
  display:'block', width:'100%', marginBottom:14, padding:'10px 12px',
  background:'var(--bg)', border:'1px solid var(--border)', borderRadius:6,
  color:'var(--text)', fontSize:14, boxSizing:'border-box',
};

const labelStyle = {
  display:'block', marginBottom:4, color:'var(--muted)', fontSize:12,
};

const submitBtn = {
  width:'100%', padding:'10px 0', background:'var(--accent)',
  border:'none', borderRadius:6, color:'#fff', fontWeight:600,
  cursor:'pointer', fontSize:14,
};
